import graphql from 'babel-plugin-relay/macro'
import Select from 'components/v2/Select'
import { fetchQuery } from 'config/amber-relay'
import useDidMount from 'hooks/useDidMount'
import React, { useEffect, useState } from 'react'

graphql`
  fragment PaymentTypeSelect_paymentType on PaymentType @relay(mask: false) {
    id
    name
  }
`

export default function PaymentTypeSelect(props) {
  const didMount = useDidMount()
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    if (didMount) setRefresh(true)
  }, [props.companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const { companyId } = props
  const selectProps = { ...props }
  delete selectProps.companyId

  const fetch = async where => {
    setRefresh(false)

    const { paymentTypes } = await fetchQuery(
      graphql`
        query PaymentTypeSelectQuery($where: PaymentTypeWhere) {
          paymentTypes(where: $where, orderBy: [code], order: ASC) {
            edges {
              node {
                ...PaymentTypeSelect_paymentType @relay(mask: false)
              }
            }
          }
        }
      `,
      { where }
    )

    return paymentTypes.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: node.name,
    }))
  }

  return (
    <Select
      {...selectProps}
      refresh={refresh}
      getByValue={value => {
        const conditions = [
          { id: { eq: value } },
          { isDisabled: { eq: 'false' } },
        ]

        if (companyId) conditions.push({ companyId: { eq: companyId } })

        return fetch({ and: conditions })
      }}
      loadOptions={searchQuery => {
        const conditions = [{ isDisabled: { eq: 'false' } }]

        if (searchQuery !== undefined)
          conditions.push({ name: { iLike: `${searchQuery}%` } })
        if (companyId) conditions.push({ companyId: { eq: companyId } })

        return fetch({ and: conditions })
      }}
    />
  )
}

PaymentTypeSelect.defaultProps = {
  label: 'Cuenta',
  placeholder: 'Cuenta',
  loadOnMount: true,
}
